import React from 'react'

const Pytm7 = () => {
    return (
        <div className='container'>
        <h1>Flattening a Linked List</h1>
        <div class="text">
<p>Given a linked list where every node represents a linked list and contains two pointers of its type:&nbsp;<br/>(i)
    Pointer to next node in the main list (we call it ‘right’ pointer in the code below)&nbsp;<br/>(ii) Pointer to a
    linked list where this node is headed (we call it the ‘down’ pointer in the code below).&nbsp;<br/>All linked
    lists are sorted. See the following example&nbsp;&nbsp;</p>
<pre>{`       5 -> 10 -> 19 -> 28
|    |     |     |
V    V     V     V
7    20    22    35
|          |     |
V          V     V
8          50    40
|                |
V                V
30               45`}</pre>
<p>Write a function flatten() to flatten the lists into a single linked list. The flattened linked list should also
    be sorted. For example, for the above input list, output list should be
    5-&gt;7-&gt;8-&gt;10-&gt;19-&gt;20-&gt;22-&gt;28-&gt;30-&gt;35-&gt;40-&gt;45-&gt;50.&nbsp;</p>

<p>The idea is to use the Merge() process ofmerge sort for linked lists. We use
    merge() to merge lists one by one. We recursively merge() the current list with the already flattened
    list.&nbsp;<br/>The down pointer is used to link nodes of the flattened list.</p>

</div>
    <div class="tabs">

<input type="radio" name="tab" id="tab2"/>
<label for="tab1">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab2">Python</label>



<div class="tab-content-wrapper">
<div id="tab-content-1" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Java program for flattening a Linked List</code>
</div>
<div class="line number2 index1 alt1"><code class="keyword">class</code> <code class="plain">LinkedList</code></div>
<div class="line number3 index2 alt2"><code class="plain">&#123;</code></div>
<div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node head;&nbsp; </code><code class="comments">// head of list</code></div>
<div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Linked list Node*/</code></div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">class</code> <code class="plain">Node</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number9 index8 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">data;</code></div>
<div class="line number10 index9 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node right, down;</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node(</code><code class="keyword">int</code> <code class="plain">data)</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">this</code><code class="plain">.data = data;</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">right = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">down = </code><code class="keyword">null</code><code class="plain">;</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// An utility function to merge two sorted linked lists</code></div>
<div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node merge(Node a, Node b)</code></div>
<div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// if first linked list is empty then second</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// is the answer</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(a == </code><code class="keyword">null</code><code
        class="plain">)&nbsp;&nbsp;&nbsp;&nbsp; </code><code class="keyword">return</code> <code
        class="plain">b;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// if second linked list is empty then first</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// is the result</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(b == </code><code class="keyword">null</code><code
        class="plain">)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </code><code class="keyword">return</code> <code
        class="plain">a;</code></div>
<div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// compare the data members of the two linked lists</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// and put the larger one in the result</code></div>
<div class="line number32 index31 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node result;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(a.data &lt; b.data)</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result = a;</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result.down =&nbsp; merge(a.down, b);</code></div>
<div class="line number38 index37 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code></div>
<div class="line number41 index40 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result = b;</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result.down = merge(a, b.down);</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result.right = </code><code class="keyword">null</code><code class="plain">;&nbsp;</code>
</div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">result;</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node flatten(Node root)</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Base Cases</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(root == </code><code class="keyword">null</code> <code
        class="plain">|| root.right == </code><code class="keyword">null</code><code class="plain">)</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">root;</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// recur for list on right</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.right = flatten(root.right);</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// now merge</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root = merge(root, root.right);</code></div>
<div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number62 index61 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// return the root</code></div>
<div class="line number63 index62 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// it will be in turn merged with its left</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">root;</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Utility function to insert a node at beginning of the</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">linked list */</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node push(Node head_ref, </code><code class="keyword">int</code> <code
        class="plain">data)</code></div>
<div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* 1 &amp; 2: Allocate the Node &amp;</code></div>
<div class="line number72 index71 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">Put in the data*/</code></div>
<div class="line number73 index72 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node new_node = </code><code class="keyword">new</code> <code class="plain">Node(data);</code>
</div>
<div class="line number74 index73 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number75 index74 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* 3. Make next of new Node as head */</code></div>
<div class="line number76 index75 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node.down = head_ref;</code></div>
<div class="line number77 index76 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number78 index77 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* 4. Move the head to point to new Node */</code></div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head_ref = new_node;</code></div>
<div class="line number80 index79 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/*5. return to link it back */</code></div>
<div class="line number82 index81 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">head_ref;</code></div>
<div class="line number83 index82 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number84 index83 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">void</code> <code class="plain">printList()</code></div>
<div class="line number86 index85 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number87 index86 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Node temp = head;</code></div>
<div class="line number88 index87 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(temp != </code><code class="keyword">null</code><code
        class="plain">)</code></div>
<div class="line number89 index88 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number90 index89 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(temp.data + </code><code class="string">" "</code><code
        class="plain">);</code></div>
<div class="line number91 index90 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp = temp.down;</code></div>
<div class="line number92 index91 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number93 index92 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println();</code></div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number96 index95 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Driver program to test above functions */</code></div>
<div class="line number97 index96 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String args[])</code></div>
<div class="line number98 index97 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number99 index98 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">LinkedList L = </code><code class="keyword">new</code> <code
        class="plain">LinkedList();</code></div>
<div class="line number100 index99 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number101 index100 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">/* Let us create the following linked list</code></div>
<div class="line number102 index101 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">5 -&gt; 10 -&gt; 19 -&gt; 28</code></div>
<div class="line number103 index102 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">|&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;&nbsp; |</code></div>
<div class="line number104 index103 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">V&nbsp;&nbsp;&nbsp; V&nbsp;&nbsp;&nbsp;&nbsp; V&nbsp;&nbsp;&nbsp;&nbsp; V</code></div>
<div class="line number105 index104 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">7&nbsp;&nbsp;&nbsp; 20&nbsp;&nbsp;&nbsp; 22&nbsp;&nbsp;&nbsp; 35</code></div>
<div class="line number106 index105 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;&nbsp; |</code>
</div>
<div class="line number107 index106 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">V&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; V&nbsp;&nbsp;&nbsp;&nbsp; V</code>
</div>
<div class="line number108 index107 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 50&nbsp;&nbsp;&nbsp; 40</code>
</div>
<div class="line number109 index108 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; |</code>
</div>
<div class="line number110 index109 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">V&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; V</code>
</div>
<div class="line number111 index110 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">30&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 45</code>
</div>
<div class="line number112 index111 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">*/</code></div>
<div class="line number113 index112 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number114 index113 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head = L.push(L.head, </code><code class="value">30</code><code class="plain">);</code>
</div>
<div class="line number115 index114 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head = L.push(L.head, </code><code class="value">8</code><code class="plain">);</code></div>
<div class="line number116 index115 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head = L.push(L.head, </code><code class="value">7</code><code class="plain">);</code></div>
<div class="line number117 index116 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head = L.push(L.head, </code><code class="value">5</code><code class="plain">);</code></div>
<div class="line number118 index117 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number119 index118 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right = L.push(L.head.right, </code><code class="value">20</code><code
        class="plain">);</code></div>
<div class="line number120 index119 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right = L.push(L.head.right, </code><code class="value">10</code><code
        class="plain">);</code></div>
<div class="line number121 index120 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number122 index121 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right = L.push(L.head.right.right, </code><code class="value">50</code><code
        class="plain">);</code></div>
<div class="line number123 index122 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right = L.push(L.head.right.right, </code><code class="value">22</code><code
        class="plain">);</code></div>
<div class="line number124 index123 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right = L.push(L.head.right.right, </code><code class="value">19</code><code
        class="plain">);</code></div>
<div class="line number125 index124 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number126 index125 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right.right = L.push(L.head.right.right.right, </code><code
        class="value">45</code><code class="plain">);</code></div>
<div class="line number127 index126 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right.right = L.push(L.head.right.right.right, </code><code
        class="value">40</code><code class="plain">);</code></div>
<div class="line number128 index127 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right.right = L.push(L.head.right.right.right, </code><code
        class="value">35</code><code class="plain">);</code></div>
<div class="line number129 index128 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head.right.right.right = L.push(L.head.right.right.right, </code><code
        class="value">20</code><code class="plain">);</code></div>
<div class="line number130 index129 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number131 index130 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// flatten the list</code></div>
<div class="line number132 index131 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.head = L.flatten(L.head);</code></div>
<div class="line number133 index132 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number134 index133 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">L.printList();</code></div>
<div class="line number135 index134 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number136 index135 alt1"><code class="plain">&#125; </code><code
        class="comments">/* This code is contributed by Rajat Mishra */</code></div>
</div>
</div>
<div id="tab-content-2" class="tab-content">
<div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python program for flattening a Linked List</code>
</div>
<div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">Node():</code></div>
<div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">,data):</code></div>
<div class="line number5 index4 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.data </code><code class="keyword">=</code> <code
        class="plain">data</code></div>
<div class="line number6 index5 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.right </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number7 index6 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.down </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number9 index8 alt2"><code class="keyword">class</code> <code class="plain">LinkedList():</code>
</div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># head of list</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1">self</code><code class="plain">.head </code><code class="keyword">=</code> <code
        class="color1">None</code></div>
<div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Utility function to insert a node at beginning of the</code></div>
<div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">#&nbsp;&nbsp; linked list&nbsp;</code></div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">push(</code><code class="color1">self</code><code
        class="plain">,head_ref,data):</code></div>
<div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># 1 &amp; 2: Allocate the Node &amp;</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Put in the data</code></div>
<div class="line number21 index20 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node </code><code class="keyword">=</code> <code class="plain">Node(data)</code></div>
<div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Make next of new Node as head</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">new_node.down </code><code class="keyword">=</code> <code class="plain">head_ref</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># 4. Move the head to point to new Node</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">head_ref </code><code class="keyword">=</code> <code class="plain">new_node</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># 5. return to link it back</code></div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">head_ref</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">printList(</code><code class="color1">self</code><code
        class="plain">):</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.head</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code><code class="plain">(temp !</code><code class="keyword">=</code> <code
        class="color1">None</code><code class="plain">):</code></div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">print</code><code class="plain">(temp.data,end</code><code class="keyword">=</code><code
        class="string">" "</code><code class="plain">)</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keyword">=</code> <code class="plain">temp.down</code></div>
<div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code><code class="plain">()</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># An utility function to merge two sorted linked lists</code></div>
<div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">merge(</code><code class="color1">self</code><code
        class="plain">, a, b):</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># if first linked list is empty then second</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># is the answer</code></div>
<div class="line number45 index44 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(a </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="color1">None</code><code class="plain">):</code></div>
<div class="line number46 index45 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">b</code></div>
<div class="line number47 index46 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
<div class="line number48 index47 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># if second linked list is empty then first</code></div>
<div class="line number49 index48 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># is the result</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(b </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="color1">None</code><code class="plain">):</code></div>
<div class="line number51 index50 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">a</code></div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># compare the data members of the two linked lists</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># and put the larger one in the result</code></div>
<div class="line number55 index54 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result </code><code class="keyword">=</code> <code class="color1">None</code></div>
<div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(a.data &lt; b.data):</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result </code><code class="keyword">=</code> <code class="plain">a</code></div>
<div class="line number59 index58 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result.down </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.merge(a.down,b)</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code><code class="plain">:</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result </code><code class="keyword">=</code> <code class="plain">b</code></div>
<div class="line number62 index61 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result.down </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.merge(a,b.down)</code></div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">result.right </code><code class="keyword">=</code> <code class="color1">None</code></div>
<div class="line number65 index64 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">result</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number67 index66 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">def</code> <code class="plain">flatten(</code><code class="color1">self</code><code
        class="plain">, root):</code></div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Base Case</code></div>
<div class="line number70 index69 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code><code class="plain">(root </code><code class="keyword">=</code><code
        class="keyword">=</code> <code class="color1">None</code> <code class="keyword">or</code> <code
        class="plain">root.right </code><code class="keyword">=</code><code class="keyword">=</code> <code
        class="color1">None</code><code class="plain">):</code></div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">root</code></div>
<div class="line number72 index71 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># recur for list on right</code></div>
<div class="line number73 index72 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number74 index73 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root.right </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.flatten(root.right)</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number76 index75 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># now merge</code></div>
<div class="line number77 index76 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">root </code><code class="keyword">=</code> <code class="color1">self</code><code
        class="plain">.merge(root, root.right)</code></div>
<div class="line number78 index77 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># return the root</code></div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># it will be in turn merged with its left</code></div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code> <code class="plain">root</code></div>
<div class="line number82 index81 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number83 index82 alt2"><code class="comments"># Driver program to test above functions&nbsp;</code>
</div>
<div class="line number84 index83 alt1"><code class="plain">L </code><code class="keyword">=</code> <code
        class="plain">LinkedList()</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number86 index85 alt1"><code class="comments">'''&nbsp;</code></div>
<div class="line number87 index86 alt2"><code class="comments">Let us create the following linked list</code></div>
<div class="line number88 index87 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">5 -&gt; 10 -&gt; 19 -&gt; 28</code></div>
<div class="line number89 index88 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">|&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;&nbsp; |</code></div>
<div class="line number90 index89 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">V&nbsp;&nbsp;&nbsp; V&nbsp;&nbsp;&nbsp;&nbsp; V&nbsp;&nbsp;&nbsp;&nbsp; V</code></div>
<div class="line number91 index90 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">7&nbsp;&nbsp;&nbsp; 20&nbsp;&nbsp;&nbsp; 22&nbsp;&nbsp;&nbsp; 35</code></div>
<div class="line number92 index91 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; |&nbsp;&nbsp;&nbsp;&nbsp; |</code>
</div>
<div class="line number93 index92 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">V&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; V&nbsp;&nbsp;&nbsp;&nbsp; V</code>
</div>
<div class="line number94 index93 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">8&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 50&nbsp;&nbsp;&nbsp; 40</code>
</div>
<div class="line number95 index94 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">|&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; |</code>
</div>
<div class="line number96 index95 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">V&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; V</code>
</div>
<div class="line number97 index96 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">30&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 45</code>
</div>
<div class="line number98 index97 alt1"><code class="comments">'''</code></div>
<div class="line number99 index98 alt2"><code class="plain">L.head </code><code class="keyword">=</code> <code
        class="plain">L.push(L.head, </code><code class="value">30</code><code class="plain">);</code></div>
<div class="line number100 index99 alt1"><code class="plain">L.head </code><code class="keyword">=</code> <code
        class="plain">L.push(L.head, </code><code class="value">8</code><code class="plain">);</code></div>
<div class="line number101 index100 alt2"><code class="plain">L.head </code><code class="keyword">=</code> <code
        class="plain">L.push(L.head, </code><code class="value">7</code><code class="plain">);</code></div>
<div class="line number102 index101 alt1"><code class="plain">L.head </code><code class="keyword">=</code> <code
        class="plain">L.push(L.head, </code><code class="value">5</code><code class="plain">);</code></div>
<div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number104 index103 alt1"><code class="plain">L.head.right </code><code class="keyword">=</code>
    <code class="plain">L.push(L.head.right, </code><code class="value">20</code><code class="plain">);</code></div>
<div class="line number105 index104 alt2"><code class="plain">L.head.right </code><code class="keyword">=</code>
    <code class="plain">L.push(L.head.right, </code><code class="value">10</code><code class="plain">);</code></div>
<div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number107 index106 alt2"><code class="plain">L.head.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right, </code><code
        class="value">50</code><code class="plain">);</code></div>
<div class="line number108 index107 alt1"><code class="plain">L.head.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right, </code><code
        class="value">22</code><code class="plain">);</code></div>
<div class="line number109 index108 alt2"><code class="plain">L.head.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right, </code><code
        class="value">19</code><code class="plain">);</code></div>
<div class="line number110 index109 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number111 index110 alt2"><code class="plain">L.head.right.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right.right, </code><code
        class="value">45</code><code class="plain">);</code></div>
<div class="line number112 index111 alt1"><code class="plain">L.head.right.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right.right, </code><code
        class="value">40</code><code class="plain">);</code></div>
<div class="line number113 index112 alt2"><code class="plain">L.head.right.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right.right, </code><code
        class="value">35</code><code class="plain">);</code></div>
<div class="line number114 index113 alt1"><code class="plain">L.head.right.right.right </code><code
        class="keyword">=</code> <code class="plain">L.push(L.head.right.right.right, </code><code
        class="value">20</code><code class="plain">);</code></div>
<div class="line number115 index114 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number116 index115 alt1"><code class="comments"># flatten the list</code></div>
<div class="line number117 index116 alt2"><code class="plain">L.head </code><code class="keyword">=</code> <code
        class="plain">L.flatten(L.head);</code></div>
<div class="line number118 index117 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
<div class="line number119 index118 alt2"><code class="plain">L.printList()</code></div>
<div class="line number120 index119 alt1"><code
        class="comments"># This code is contributed by maheshwaripiyush9</code></div>
</div>
</div>

</div>
</div>
<br /> <br /> <br /> <br /> <br />
</div>
    )
}

export default Pytm7
